import { Table } from 'antd';
import type { TablePaginationConfig } from 'antd/es/table';
import { localize } from 'mixins/helpers';
import React, { FC, useMemo } from 'react';
import { ApiAccessRecord } from '/react4xp/parts/admin-api-access/types';
import { DEFAULT_PAGE_SIZE } from '../utils/constants';
import { getApiAccessColumns } from './api-access-columns';

interface ApiAccessTableProps {
    data: ApiAccessRecord[];
    disabled: boolean;
    isLoading: boolean;
    pagination: TablePaginationConfig;
    translations: Record<string, string>;
    onChange: (pagination: TablePaginationConfig) => void;
    onAllowedChange: (apiCode: string, isAllowed: boolean) => void;
    onLimitChange: (apiCode: string, limitPerDay: number | null) => void;
    onMinuteLimitChange: (apiCode: string, limitPerMinute: number | null) => void;
}

export const ApiAccessTable: FC<ApiAccessTableProps> = ({
    data,
    disabled,
    isLoading,
    onChange,
    onAllowedChange,
    onLimitChange,
    onMinuteLimitChange,
    pagination,
    translations,
}) => {
    const columns = useMemo(
        () =>
            getApiAccessColumns({
                disabled,
                onAllowedChange,
                onLimitChange,
                onMinuteLimitChange,
                pagination,
                translations,
            }),
        [
            disabled,
            onAllowedChange,
            onLimitChange,
            onMinuteLimitChange,
            pagination,
            translations,
        ]
    );

    return (
        <Table<ApiAccessRecord>
            rowKey="apiCode"
            columns={columns}
            dataSource={data}
            loading={isLoading}
            rowClassName={(record) =>
                record.isAllowed ? '' : 'admin-api-access__row--disabled'
            }
            locale={{
                emptyText: localize('admin-api-access-no-data', translations),
            }}
            pagination={{
                ...pagination,
                pageSize: pagination.pageSize || DEFAULT_PAGE_SIZE,
                showSizeChanger: false,
                showTotal: undefined,
                responsive: false,
                className: 'admin-api-access__pagination',
            }}
            scroll={{ x: 1200 }}
            onChange={onChange}
        />
    );
};